module.exports = __webpack_public_path__ + "media/images/sp/top/clean_side-5a3b34b8525542f01ec25cb78d768ba2.png";